import React from "react";
export const Divider = (props) => {
    return (
        <div style={{borderBottom: '1px solid #cccccc', marginBottom: 10, ...props?.style}}></div>
    )
}

export default Divider;